;(function () {
  'use strict'

  angular
    .module('deskfy.core')
    .directive('imgFallback', imgFallback)

  function imgFallback () {
    return {
      link: function postLink (scope, iElement, iAttrs) {
        iElement.bind('error', function () {
          if (scope[iAttrs.imgFallback]) {
            angular.element(this).attr('src', scope[iAttrs.imgFallback]())
          } else if (scope.$ctrl && scope.$ctrl[iAttrs.imgFallback]) {
            angular.element(this).attr('src', scope.$ctrl[iAttrs.imgFallback]())
          }
        })
      }
    }
  }
})()
